export default "__VITE_ASSET__BUaqXHw7__"